<template>
    <div class="cg-left">
        <TopTabs :tabsObj="topTitle" />

        <div class="cg-left__content">
            <div class="tabs">
                <!-- 河湖岛工程列表 -->
                <div v-if="searchForm.currentTab == 'riverLakeIslandAndProject'" class="tab-content" key="tab0">
                    <div class="left-top display">
                        <div>{{ $t('hezhang.index.leftAside.type') }}</div>
                        <div v-for="(item, index) in leftTabList" :key="item.value" class="display">
                            <el-checkbox v-model="item.checked" @click.native="(event) => event.stopPropagation()"
                                @change="handleTabCheckChange(item, index, $event)"></el-checkbox>
                            <div class="checkbox-txt">{{ $t(item.label) }}</div>
                        </div>
                    </div>
                    <el-scrollbar class="tab-scrollbar">
                        <div v-if="heHuIslandProjectList.length > 0">
                            <RiverLakeIslandItem v-for="item in heHuIslandProjectList" :key="item.id" :data="item"
                                :activityId="heHuIslandActivityId" @clickItemPositioning="clickItemPositioning">
                            </RiverLakeIslandItem>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center"
                            :total="heHuIslandProjectPage.total" :pageSize.sync="heHuIslandProjectPage.pageSize"
                            :currentPage.sync="heHuIslandProjectPage.currentPage" layout="total,prev, pager, next"
                            @current-change="getHeHuIslandProject">
                        </el-pagination>
                    </div>
                </div>

                <!-- 事件分布-->
                <div v-else-if="searchForm.currentTab == 'events'" class="tab-content" key="tab2">
                    <div class="search-wrap mg-bottom-16">
                        <el-input clearable v-model.trim.lazy="searchForm.keyWord" class="c-el-input-blue mg-bottom-8"
                            :placeholder="$t('chengguan.index.leftAside.enterName')">
                            <el-button class="btn-search" slot="append" icon="el-icon-search"
                                @click="getEventList(1)"></el-button>
                        </el-input>
                        <el-row :gutter="8" class="mg-bottom-8">
                            <el-col :span="12">
                                <el-cascader class="el-select-blue" v-model="searchForm.eventTypeId"
                                    :options="eventTypeOptions" :props="eventTypeCascaderProps"
                                    :placeholder="$t('chengguan.index.leftAside.eventType')" clearable
                                    popper-class="el-cascader__dropdown-blue"></el-cascader>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="searchForm.eventStatus" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('chengguan.index.leftAside.allStatuses')" clearable>
                                    <el-option v-for="item in eventStatusOptions" :key="item.dictValue"
                                        :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <el-scrollbar class="tab-scrollbar-3">
                        <div v-if="eventList.length > 0">
                            <EventListItem v-for="item in eventList" :key="item.id" :data="item"
                                @click="handleEventListClick">
                            </EventListItem>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center"
                            :total="eventsPage.total" :pageSize.sync="eventsPage.pageSize"
                            :currentPage.sync="eventsPage.currentPage" layout="total,prev, pager, next"
                            @current-change="getEventList">
                        </el-pagination>
                    </div>
                </div>
                <!-- 照片分布 -->
                <div v-else-if="searchForm.currentTab == 'photos'" class="tab-content" key="tab3">
                    <div class="search-wrap mg-bottom-16">
                        <el-row :gutter="8" class="mg-bottom-8">
                            <el-col :span="12">
                                <el-select v-model="pictureSearchForm.serviceOrderId" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('hezhang.index.leftAside.selectionService')" clearable
                                    @visible-change="handleServicePageVisibleChange">
                                    <el-option v-for="item in serviceOrderOptions" :key="item.id" :label="item.label"
                                        :value="item.value"></el-option>
                                    <!-- 分页控件 -->
                                    <div class="service-select-pagination"
                                        v-if="servicePage.total > servicePage.pageSize">
                                        <el-pagination small layout="prev, pager, next"
                                            :current-page="servicePage.currentPage" :page-size="servicePage.pageSize"
                                            :total="servicePage.total"
                                            @current-change="handleServicePageChange"></el-pagination>
                                    </div>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="pictureSearchForm.scopeGeometry" class="el-select-blue"
                                    popper-class="c-el-select-dropdown-blue"
                                    :placeholder="$t('hezhang.index.leftAside.shootingRange')" clearable>
                                    <el-option v-for="item in rangeOptions" :key="item.id" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>

                    <el-scrollbar class="tab-scrollbar">
                        <div v-if="currentPhotoPageData.length > 0">
                            <photoDistributionItem v-for="item in currentPhotoPageData" :key="item.id" :data="item"
                                :activeId="photoActiveId" @click="handlePhotoListClick"></photoDistributionItem>
                        </div>
                        <CustomEmpty v-else />
                    </el-scrollbar>
                    <div>
                        <el-pagination class="c-el-pagination-blue" small background align="center"
                            :total="photoPage.total" :pageSize.sync="photoPage.pageSize"
                            :currentPage.sync="photoPage.currentPage" layout="total,prev, pager, next"
                            @current-change="getPhotoPage">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增服务申请单 -->
        <el-dialog :title="addRequestFormDialog.title" :visible.sync="addRequestFormDialog.visible"
            :modal-append-to-body="false" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true"
            custom-class="form-dialog" width="950px">
            <ServiceAddForm :appCode="appCode" id="" mode="add" @close="onDialogClose" />
        </el-dialog>
    </div>
</template>
<script>
import TopTabs from '@/components/topTabs.vue';
import RiverLakeIslandItem from '@/page/business/hezhang/components/riverLakeIslandItem.vue';
import photoDistributionItem from '@/page/business/components/photoDistributionItem/index.vue';

import EventListItem from '@/components/events/EventListItem';

import ServiceAddForm from '@/page/service/iframe-form.vue';
import Api from '../../api';
import CWApi from '@/page/business/chengguan/api/index.js';

import serviceApi from '@/page/service/api.js';
import DicApi from '@/api/system/dic';
import DatepickerMixin from '@/mixins/datepicker.js';
import { getLayerSrcAndBbox } from '@/components/map/utils';
import { leftTabList } from './configData/DataConfig.js';
/**
 *
 * @description 左侧导航
 * emits: checkGrid 勾选网格分组,tabChange:切换tab
 */
export default {
    mixins: [DatepickerMixin],
    components: {
        TopTabs,
        RiverLakeIslandItem,
        photoDistributionItem,
        ServiceAddForm,
        EventListItem,
    },
    props: {
        onZhengSheData: {
            // 父组件通过传递这个函数去接收请求到的正射影像列表
            type: Function,
            default: () => { },
        },
        onEventData: {
            // 父组件通过传递这个函数去接收请求到的事件列表
            type: Function,
            default: () => { },
        },
        onPictureData: {
            // 父组件通过传递这个函数去接收请求到的照片列表
            type: Function,
            default: () => { },
        },
        searchForm: {
            // 父组件通过传递这个函数去接收请求到的事件列表
            type: Object,
            default: () => ({
                queryDate: [],
                eventTypeId: '',
                currentTab: '',
                eventStatus: '',
            }),
        },
        // 默认全选地图显示数据 ['events', 'photos', 'grid', 'ortho']
        tabControlList: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
            topTitle: {},
            leftTabList /** 河长左侧列表配置信息 */,

            addRequestFormDialog: { title: this.$t('service.list.titleAddForm'), visible: false },
            heHuIslandActivityId: null,
            heHuIslandObj: {
                total: 0,
                list: [],
            },
            projectObj: {
                total: 0,
                list: [],
            },
            heHuIslandProjectParamList: [],

            // 河湖岛项目列表
            heHuIslandProjectList: [],
            heHuIslandProjectPage: {
                total: 0,
                type: 'RIVER,LAKE,ISLAND',
                pageSize: 20,
                currentPage: 1,
            },

            // 照片列表
            photoActiveId: null, // 当前激活的照片id
            photoList: [],
            // 当前页要展示的数据
            currentPhotoPageData: [],

            serviceOrderOptions: [], // 服务下拉框选项列表
            servicePage: {
                total: 0,
                pageSize: 5,
                currentPage: 1,
            },
            rangeOptions: [], // 拍摄范围下拉框选项列表
            pictureSearchForm: {
                serviceOrderId: '',
                scopeGeometry: '',
            },
            photoPage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },

            // 事件类型下拉框选项
            eventTypeOptions: [],
            eventTypeCascaderProps: {
                label: 'name',
                value: 'id',
                emitPath: false,
            },
            // 事件状态下拉框选项
            eventStatusOptions: [],
            eventsPage: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },

            eventList: [],
            // 默认展开的网格组
            collapseExpandNames: [],
        };
    },
    watch: {
        searchForm: {
            handler (newVal, oldVal) {
                this.topTitle = {
                    centre: this.$t(`businessConfig.control.${newVal.currentTab}`),
                    type: 3,
                };

                if (newVal.queryDate.length > 0) {
                    this.getEventList(1);
                    this.hzDataPicture();
                    this.getRiverLakeIslandList();
                }
            },
            immediate: true,
            deep: true,
        },
        tabControlList: {
            handler (newVal, oldVal) {
                console.log('tabControlList 变化：', newVal, oldVal);
                // eslint-disable-next-line no-param-reassign
                oldVal = oldVal || []; // 初始化旧值为空数组，避免首次加载时 undefined
                // 1. 找出新增的字段（新值有，旧值没有）
                const addedFields = newVal.filter((item) => !oldVal.includes(item));
                // 2. 找出移除的字段（旧值有，新值没有）
                const removedFields = oldVal.filter((item) => !newVal.includes(item));

                this.$nextTick(() => {
                    // 处理新增字段：请求对应接口
                    addedFields.forEach((field) => {
                        // console.log('新增字段：', field);
                        this.getFields(field);
                    });

                    // 处理移除字段：清空对应数据
                    removedFields.forEach((field) => {
                        // console.log('移除字段：', field);
                        this.removedFields(field);
                    });
                });
            },
            immediate: true,
            deep: true,
        },
        heHuIslandProjectParamList: {
            handler (newVal) {
                this.heHuIslandProjectList = [];
                this.heHuIslandObj = { total: 0, list: [] };
                this.projectObj = { total: 0, list: [] };
                let typeList = [];
                let project = '';

                if (newVal.length > 0) {
                    newVal.forEach((item) => {
                        if (item === 'PROJECT') {
                            project = item;
                        } else {
                            typeList.push(item);
                        }
                    });
                }
                this.heHuIslandProjectPage.type = typeList.join(',');
                typeList.length > 0 && this.getRiverLakeIslandList();
                project && this.getProjectList();
            },
            deep: true,
        },
        // 合并逻辑统一，监听两个对象的变化，基于最新数据重新计算
        heHuIslandObj: {
            handler() {
                this.mergeProjectLists(); // 触发合并
            },
            immediate: true,
            deep: true,
        },
        projectObj: {
            handler() {
                this.mergeProjectLists(); // 触发合并
            },
            immediate: true,
            deep: true,
        },

        heHuIslandProjectList: {
            handler (newVal) {
                this.$emit('checkHeHuIslandProjectList', newVal);
                if (newVal.length > 0) {
                    this.rangeOptions = newVal.map((item) => ({ label: item.name, value: item.geometry, id: item.id }));
                }
            },
            immediate: true,
            deep: true,
        },
        pictureSearchForm: {
            handler (newVal) {
                this.hzDataPicture();
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        appCode () {
            // 取当前所属应用，优先从路由参数中取，如果没有再从localStorage中取
            // 指定默认为：城管应用（CW）
            let appCode = this.$route.query.appCode || localStorage.getItem('appCode') || 'HZ';
            return appCode;
        },
    },
    methods: {
        /**
     * 合并两个列表并去重（核心优化）
     * 基于唯一标识（假设数据项有唯一id，可根据实际字段调整）
     */
        mergeProjectLists() {
            // 1. 获取两个源列表的最新数据
            const heHuList = this.heHuIslandObj.list || [];
            const projectList = this.projectObj.list || [];

            // 2. 合并并去重（使用Map根据id去重，保留后出现的项）
            const mergedMap = new Map();
            // 先添加第一个列表
            heHuList.forEach((item) => mergedMap.set(item.id, item));
            // 再添加第二个列表（若id重复，会覆盖前面的，可根据需求调整顺序）
            projectList.forEach((item) => mergedMap.set(item.id, item));

            // 3. 转换为数组，赋值给目标列表
            this.heHuIslandProjectList = Array.from(mergedMap.values());

            // 4. 计算总条数（直接相加，无需依赖历史total）
            this.heHuIslandProjectPage.total = (this.heHuIslandObj.total || 0) + (this.projectObj.total || 0);
        },

        // 根据地图中间字段获取数据
        getFields (field) {
            // eslint-disable-next-line default-case
            switch (field) {
                case 'events':
                    this.getEventList(1); // 请求事件数据
                    break;
                case 'photos':
                    // 假设存在照片数据请求方法（根据实际业务补充）
                    this.hzDataPicture();
                    break;
                case 'riverLakeIslandAndProject':
                    this.getProjectList();
                    this.getRiverLakeIslandList(); // 请求河湖岛和项目数据
                    break;
            }
        },
        // 根据地图中间字段移除数据
        removedFields (field) {
            // eslint-disable-next-line default-case
            switch (field) {
                case 'events':
                    this.eventList = []; // 清空事件数据
                    this.eventsPage.total = 0; // 清空分页
                    this.onEventData([]);
                    break;
                case 'photos':
                    // 假设存在照片数据数组（根据实际业务补充）
                    this.currentPhotoPageData = [];
                    this.photoList = []; // 清空照片数据
                    this.photoPage = {
                        total: 0,
                        pageSize: 10,
                        currentPage: 1,
                    };
                    this.onPictureData([]);
                    break;
                case 'riverLakeIslandAndProject':
                    this.heHuIslandProjectList = []; // 清空河湖岛和项目数据

                    break;
            }
        },

        handleTabCheckChange (tab, index, checked) {
            if (checked === undefined) {
                tab.checked = !tab.checked;
            }
            const checkedItems = this.leftTabList.filter((item) => item.checked);
            this.heHuIslandProjectParamList = checkedItems.map((item) => item.value);
        },

        /**
         * 定位图标点击事件
         *
         * @param {Object} item - 被点击的对象
         */
        clickItemPositioning (item) {
            this.$emit('dingweiClick', item);
            this.heHuIslandActivityId = item.id;
        },

        handleViewClick (task) {
            this.$router.push({
                path: '/hezhang/dailypatrol',
                query: {
                    // 关键：将数组转为JSON字符串，避免路由自动序列化为对象
                    queryDate: JSON.stringify(this.searchForm.queryDate),
                },
            });
        },

        /**
         * 处理事件列表点击事件
         *
         * @param item 点击的事件项
         */
        handleEventListClick (item) {
            this.$emit('eventListClick', item);
        },

        /**
         * 处理表格折叠变化事件
         *
         * @param gridGroupId 网格分组ID
         */
        handleGridCollapseChange (gridGroupId) {
            if (gridGroupId) {
                this.heHuIslandProjectPage.currentPage = 1;
                if (typeof gridGroupId === 'string') {
                    this.getGridGroupData(gridGroupId);
                }
            }
        },
        addRequestForm () {
            this.addRequestFormDialog.visible = true;
        },
        onDialogClose () {
            this.addRequestFormDialog.visible = false;
        },
        /**
         * 获取河湖岛列表：
         *
         * @returns {Promise<Array>} 返回一个包含任务列表的Promise对象
         */
        getRiverLakeIslandList () {
            let param = {
                pageNum: this.heHuIslandProjectPage.currentPage,
                pageSize: this.heHuIslandProjectPage.pageSize,
                type: this.heHuIslandProjectPage.type,
                'params[beginTime]': this.searchForm.queryDate[0],
                'params[endTime]': this.searchForm.queryDate[1],
            };
            this.heHuIslandObj = { total: 0, list: [] };

            Api.riverLakeIslandList(param).then((res) => {
                if (res.code === 200) {
                    let list = res.rows || [];
                    // console.log('获取河湖岛列表：', list);
                    this.heHuIslandObj = { list, total: res.total };
                }
            });
        },

        /**
         * 获取工程列表：
         *
         * @returns {Promise<Array>} 返回一个包含获取工程列表：的Promise对象
         */
        getProjectList () {
            let param = {
                pageNum: this.heHuIslandProjectPage.currentPage,
                pageSize: this.heHuIslandProjectPage.pageSize,
                'params[beginTime]': this.heHuIslandProjectPage['params[beginTime]'],
                'params[endTime]': this.heHuIslandProjectPage['params[endTime]'],
            };
            this.projectObj = { list: [], total: 0 };
            Api.projectList(param).then((res) => {
                if (res.code === 200) {
                    let list = res.rows || [];
                    // console.log('获取工程列表：', list);
                    this.projectObj = { list, total: res.total };
                }
            });
        },
        // 分页查询河湖岛工程
        getHeHuIslandProject (page) {
            this.heHuIslandProjectPage.currentPage = page;
            this.getRiverLakeIslandList();
            this.getProjectList();
        },

        /**
         * 获取图片列表
         */
        hzDataPicture () {
            if (this.searchForm.queryDate.length === 0) return;
            let param = {
                beginTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                appCode: this.appCode,
                ...this.pictureSearchForm,
            };
            CWApi.taskDataPictureList(param).then((res) => {
                console.log('获取图片列表：', res);
                if (res.code === 200) {
                    this.photoList = res.data || [];
                    this.photoPage.total = res.data.length || 0;
                    if (typeof this.onPictureData === 'function') {
                        this.onPictureData(JSON.parse(JSON.stringify(res.data)));
                    }
                    this.getCurrentPageData(); // 重新计算当前页数据
                }
            });
        },
        // 计算当前页数据
        getCurrentPageData () {
            const { currentPage, pageSize } = this.photoPage;
            // 计算截取的起始索引和结束索引
            const startIndex = (currentPage - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            // 截取原始数据，得到当前页数据
            this.currentPhotoPageData = this.photoList.slice(startIndex, endIndex);
        },

        getPhotoPage (page) {
            this.photoPage.currentPage = page;
            this.getCurrentPageData(); // 重新计算当前页数据
        },
        handlePhotoListClick (item) {
            this.$emit('eventListClick', item);
            this.photoActiveId = item.id;
        },

        /**
         * 获取事件列表
         */
        getEventList (page) {
            let pageNum = page || 1;
            this.eventsPage.currentPage = pageNum;

            let param = {
                startTime: this.searchForm.queryDate[0],
                endTime: this.searchForm.queryDate[1],
                name: this.searchForm.keyWord,
                pageNum: this.eventsPage.currentPage,
                pageSize: this.eventsPage.pageSize,
            };
            if (this.searchForm.eventStatus) {
                param.status = this.searchForm.eventStatus;
            }
            if (this.searchForm.eventTypeId) {
                param.eventTypeId = this.searchForm.eventTypeId;
            }
            Api.fetchEventList(param).then((res) => {
                let resList = [];
                let total = 0;
                // console.log('获取事件列表：', res);
                if (res.code === 200) {
                    total = res.total || 0;
                    resList = res.rows || [];
                }
                this.eventsPage.total = total;
                this.eventList = resList;
                if (typeof this.onEventData === 'function') {
                    this.onEventData(JSON.parse(JSON.stringify(resList)));
                }
            });
        },

        /**
         * 获取事件状态字典
         */
        getEventStatusDic () {
            DicApi.fetchEventStatusDic().then((res) => {
                this.eventStatusOptions = res.data || [];
            });
        },
        getEventTypeTree () {
            Api.fetchEventTypeTree().then((res) => {
                // console.log(res, 'eventTypeTree');
                if (res.code === 200) {
                    this.eventTypeOptions = res.data || [];
                }
            });
        },
        async getListServiceOrder () {
            let param = {
                pageNum: this.servicePage.currentPage,
                pageSize: this.servicePage.pageSize,
            };
            const res = await serviceApi.listServiceOrder(param);
            let list = res.rows || [];
            if (list.length > 0) {
                this.serviceOrderOptions = list.map((item) => ({ id: item.id, value: item.id, label: item.name }));
            }
            this.servicePage.total = res.total;
        },

        // 分页查询服务单
        handleServicePageChange (num) {
            this.servicePage.currentPage = num;
            this.getListServiceOrder();
        },
        handleServicePageVisibleChange () {
            this.servicePage.currentPage = 0;
            this.getListServiceOrder();
        },
    },
    created () {
        this.getEventStatusDic();
        this.getEventTypeTree();
        this.getListServiceOrder();
    },
    mounted () { },
};
</script>
<style lang="scss" scoped>
$topTitleHeight: 65px;
$topButtonHeight: 36px;
$tapItemHeight: 32px;
$colorLightBlue: #49f0fd;

.cg-left {
    height: 100%;
    position: relative;

    &__content {
        padding: 16px;
        padding-top: 0px;
        // height: calc(100% - #{$topTitleHeight});
        height: 100%;

        .left-top {
            padding: 10px 0;

            .checkbox-txt {
                margin-left: 5px;
                line-height: 17px;
            }
        }

        ::v-deep .el-checkbox {
            &__inner {
                background-color: transparent;
                border-color: $colorLightBlue;
            }

            &__input.is-checked {
                .el-checkbox__inner::after {
                    border-color: $colorLightBlue;
                }
            }
        }
    }

    .tabs {
        position: relative;
        // height: calc(100% - #{$topButtonHeight} - 16px);
        height: 100%;

        &__header {
            // display: flex;
            display: block;
            box-sizing: border-box;
            //margin-bottom: 16px;
        }

        &__header-item {
            // flex: 1;
            min-width: 94px;
            padding: 0 6px;
            display: inline-flex;
            box-sizing: border-box;
            align-items: center;
            justify-content: center;
            height: $tapItemHeight;
            text-align: center;
            background: linear-gradient(180deg, rgba(7, 17, 80, 0.33) 0%, rgba(15, 60, 170, 0.31) 100%);
            border-radius: 1px 1px 1px 1px;
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(73, 240, 253, 0), rgba(73, 240, 253, 0.3)) 1 1;
            cursor: pointer;

            &.is-active {
                color: #49f0fd;
                background: linear-gradient(180deg, #071150 0%, #0f3caa 100%);
                box-shadow: inset 0px -3px 4px 0px rgba(153, 255, 255, 0.2);
                border-radius: 1px 1px 1px 1px;
                border: 1px solid;
                border-image: linear-gradient(180deg, rgba(73, 240, 253, 0), rgba(73, 240, 253, 1)) 1 1;
            }
        }

        .tab-content {
            position: relative;
            height: calc(100% - #{$tapItemHeight} - 16px);
        }

        .tab-scrollbar {
            $searchHeight: 32px;
            height: calc(100% - #{$searchHeight} - 50px);
        }

        .tab-scrollbar-2 {
            $searchHeight: 72px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }

        .tab-scrollbar-3 {
            $searchHeight: 112px;
            $pageHeight: 30px;
            height: calc(100% - #{$searchHeight} - #{$pageHeight});
        }

        ::v-deep {

            .tab-scrollbar,
            .tab-scrollbar-2,
            .tab-scrollbar-3 {
                .el-scrollbar__wrap {
                    overflow-x: hidden;
                }

                .el-scrollbar__thumb {
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        right: 0px;
                        bottom: 0px;
                        background: linear-gradient(to bottom,
                                rgba(73, 240, 253, 1),
                                rgba(73, 240, 253, 0.4),
                                rgba(73, 240, 253, 0.4),
                                rgba(73, 240, 253, 1));
                        border-radius: inherit;
                        z-index: -1;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        top: 1px;
                        left: 1px;
                        right: 1px;
                        bottom: 1px;
                        background: rgba(7, 17, 80, 0.8);
                        border-radius: inherit;
                        z-index: 1;
                    }
                }
            }
        }

        ::v-deep .el-collapse {
            border-top: none !important;
            border-bottom: none !important;

            &-item {
                &__header {
                    color: #ffffff;
                    background-color: transparent;
                    border-bottom: none !important;
                    height: 32px;
                    line-height: 32px;
                }

                &__wrap {
                    background-color: transparent;
                    border-bottom: none;
                }

                &__arrow {
                    color: #49f0fd;
                }

                &__content {
                    color: #ffffff;
                    padding-bottom: 12px;
                }
            }
        }

        .list-item {
            display: flex;
            box-sizing: border-box;
            align-items: center;
        }

        .collapse-list-item,
        .list-item {
            padding: 6px 8px;
            background: #112d7b;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #1a47a4;
            font-size: 14px;

            &:not(:last-child) {
                margin-bottom: 8px;
            }

            &:hover,
            &.is-active {
                background: #1a47a4;
            }

            .view-text {
                color: $colorLightBlue;
                cursor: pointer;
            }

            .time-text {
                color: rgba(255, 255, 255, 0.6);
                font-size: 12px;
            }
        }

        .list-item__checkbox {
            display: flex;
            box-sizing: border-box;
            align-items: center;
            color: rgba(255, 255, 255, 0.9);
        }

        .list-item {
            &__title {
                color: rgba(255, 255, 255, 0.9);
            }

            &__time {
                color: #a1a1a1;
            }
        }
    }
}

/* 分页容器（限定在service-select-pagination内） */
.service-select-pagination .el-pagination {
    /* 调整分页整体文字颜色 */
    color: #ffffff;
    /* 基础文字色 */
    background-color: #1a47a4;
}

/* 页码按钮默认样式 */
::v-deep .el-pager li {
    color: #ffffff;
    /* 页码文字色 */
    border-color: #d1d9e6;
    /* 边框色 */
    background-color: #1a47a4;
    /* 背景色 */
}

::v-deep .el-pager li.active {
    background-color: #49f0fd !important;
}

/* 页码按钮 hover 状态 */
.service-select-pagination .el-pager li:not(.disabled):hover {
    color: #2783fb;
    /*  hover文字色 */
    border-color: #b8d1f3;
    /*  hover边框色 */
    background-color: #071150;
    /*  hover背景色 */
}

/* 当前页码按钮（核心突出样式） */
::v-deep .service-select-pagination .el-pager li.active {
    color: #fff;
    /* 当前页文字色（白色更醒目） */
    background-color: #49f0fd !important;
    /* 当前页背景色（主色调） */
    border-color: #49f0fd !important;
    /* 当前页边框色（与背景一致） */
}

/* 禁用状态（上一页/下一页/页码） */
::v-deep .el-pagination button:disabled,
::v-deep .el-pager li.disabled {
    color: #c9cdD4;
    /* 禁用文字色 */
    border-color: #e5e6eb;
    /* 禁用边框色 */

    background-color: #2783fb !important;
    /* 禁用背景色 */
}

::v-deep .btn-prev,
::v-deep .btn-next {
    background-color: #2783fb !important;
    color: #ffffff;
    padding: 0 8px;
}

.display {
    display: flex;
    justify-content: space-between;
}

::v-deep .el-dialog {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background: #071150;
    box-shadow: inset 0px 0px 10px 0px #49f0fd;
    border: 1px solid #49f0fd;

    .el-dialog__header {
        padding: 18px 0 18px 24px;
        border-bottom: 1px solid #49f0fd;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;

        .el-dialog__title {
            height: 21px;
            font-size: 16px;
            font-weight: 400;
            color: #49f0fd;
            line-height: 19px;
        }
    }

    .el-dialog__body {

        .el-input__inner,
        .el-textarea__inner {
            background-color: #071150;
            border: 1px solid rgba(135, 161, 216, 0.7);
            color: #fff;
        }

        .el-form-item.is-error .el-input__inner {
            border-color: #f56c6c;
        }

        .upload-demo {
            width: 750px;
        }

        .el-upload-dragger {
            background: #071150;
            width: 769px;
        }

        .el-form-item__label {
            color: #fff !important;
            font-size: 14px;
        }

        .el-button {
            width: 144px;
            height: 34px;
            font-size: 14px;
            background: rgba(73, 240, 253, 0.2);
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #49f0fd;
        }

        .el-button--primary {
            color: #fff;
        }

        .el-button--primary:hover {
            color: #409eff;
        }
    }

    &.form-dialog {
        .el-dialog__body {
            padding: 0px;
        }
    }

    .fix-close {
        position: absolute;
        top: -20px;
        right: -20px;
        cursor: pointer;
    }
}
</style>
